// extracted by mini-css-extract-plugin
export var container = "AdminInput_container__MgJgv";
export var dateInput = "AdminInput_dateInput__BDViL";
export var error = "AdminInput_error__NGN-L";
export var errorMessage = "AdminInput_errorMessage__8RDYb";
export var input = "AdminInput_input__FXgC4";
export var md = "768px";
export var priceInput = "AdminInput_priceInput__9SJ-J";
export var shared = "\"../../shared.module.css\"";
export var textArea = "AdminInput_textArea__NYizh";
export var xl = "1200px";